module.exports = __webpack_public_path__ + "img/double-card.f6691793.png";